import 'react-app-polyfill/ie11';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import 'antd/dist/antd.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import myStore from './store/createStore';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import setupAxiosInterceptors from './globals/interceptors';
import { reactPlugin } from '@config/telemetry';
import ClevertapReact from 'src/utils/clever-tap';
import { hotjar } from 'react-hotjar';
import TagManager from 'react-gtm-module';

ClevertapReact.initialize(process.env.REACT_APP_CLEVERTAP_ID);
hotjar.initialize({ id: process.env.REACT_APP_HOTJAR_ID, sv: 6 });
if (process.env.REACT_APP_GTM_ID) {
	TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
}

const store = myStore();
setupAxiosInterceptors(store);

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<AppInsightsContext.Provider value={reactPlugin}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</AppInsightsContext.Provider>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
